var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "name-headline-description" },
    [
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { sm: "5" } }, [
            _c("label", { attrs: { for: "name" } }, [
              _vm._v("\n                Card Name\n                "),
              _c("p", [
                _c("small", [
                  _vm._v("Give it a unique name to find it quicker"),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "7" } },
            [
              _vm.cardNameError
                ? [
                    _c("small", { staticClass: "error" }, [
                      _vm._v(
                        "This card name already exists. Choose a different name."
                      ),
                    ]),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("b-form-input", {
                class: { error: _vm.cardNameError },
                staticStyle: { "font-weight": "bold" },
                attrs: {
                  id: "name",
                  type: "text",
                  placeholder: "Card XXX",
                  required: "",
                  autofocus: "",
                },
                model: {
                  value: _vm.value.cardName,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "cardName", $$v)
                  },
                  expression: "value.cardName",
                },
              }),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("divider"),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { sm: "5" } }, [
            _c("label", { attrs: { for: "title" } }, [
              _vm._v("\n                Headline\n                "),
              _c("p", [_c("small", [_vm._v("Write an engaging headline")])]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "7" } },
            [
              _c("b-form-input", {
                attrs: {
                  id: "title",
                  type: "text",
                  placeholder: "This is my title",
                  required: "",
                },
                model: {
                  value: _vm.value.cardTitle,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "cardTitle", $$v)
                  },
                  expression: "value.cardTitle",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { sm: "5" } }, [
            _c("label", { attrs: { for: "description" } }, [
              _vm._v("\n                Description\n                "),
              _c("p", [_c("small", [_vm._v("Keep it short and simple")])]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "7" } },
            [
              _c("b-form-textarea", {
                attrs: {
                  id: "description",
                  rows: 2,
                  "max-rows": 4,
                  placeholder: "This is my Description",
                  required: "",
                },
                model: {
                  value: _vm.value.cardDescription,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "cardDescription", $$v)
                  },
                  expression: "value.cardDescription",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }